import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    issueDate:
      'It dates back to less than three months (issued after {earliestIssueDate})',
    message:
      'Please help us validate your account faster by checking your document one last time',
    mostRecent: 'The document is the most recent',
    superiorToContribution:
      'The amount of your salary is greater than or equal to the amount of the cash contribution',
  },
  fr: {
    issueDate:
      'Votre document est daté de moins de 3 mois (émis après le {earliestIssueDate})',
    message:
      'Pour nous aider à valider votre compte plus rapidement, prenez quelques minutes pour vérifier une dernière fois votre document.',
    mostRecent: 'Votre document est le dernier en date',
    superiorToContribution:
      'Le montant de votre salaire est supérieur ou égal au montant de l’apport en numéraire',
  },
} as const);
